"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var shared_1 = require("../../../../../shared");
var Dropdown_meta_1 = require("./Dropdown.meta");
var Button_1 = __importDefault(require("../Button"));
var ClickLayer_1 = __importDefault(require("../../../ClickLayer"));
var Icon_1 = __importDefault(require("../../styledComponents/Icon"));
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.categoryKey = Dropdown_meta_1.DROPDOWN_CATEGORY_KEY;
        _this.componentKey = Dropdown_meta_1.DROPDOWN_COMPONENT_KEY;
        return _this;
    }
    Object.defineProperty(Dropdown.prototype, "parentComponentKey", {
        get: function () {
            return Dropdown_meta_1.DROPDOWN_PARENT_COMPONENT_KEY;
        },
        enumerable: true,
        configurable: true
    });
    Dropdown.prototype.render = function () {
        var _a = this.props, children = _a.children, buttonProps = _a.buttonProps, contextMenuLabel = _a.contextMenuLabel, asset = _a.asset, toggleDropdown = _a.toggleDropdown, open = _a.open, iconAlt = _a.iconAlt, hideAsset = _a.hideAsset, className = _a.className;
        return (react_1.default.createElement("div", { className: className },
            react_1.default.createElement(Button_1.default, __assign({}, buttonProps),
                contextMenuLabel,
                !hideAsset && (react_1.default.createElement(Icon_1.default, { alt: iconAlt || 'Context Menu Icon', asset: asset }))),
            open && (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement(ClickLayer_1.default, { onClick: toggleDropdown }),
                react_1.default.createElement("div", { style: {
                        display: 'flex',
                        justifyContent: 'flex-start',
                        minWidth: '150px',
                    } }, children)))));
    };
    Dropdown = __decorate([
        mobx_react_1.observer
    ], Dropdown);
    return Dropdown;
}(shared_1.ComponentBase));
exports.Dropdown = Dropdown;
exports.default = shared_1.InjectedStyledComponent(Dropdown, Dropdown_meta_1.DROPDOWN_CATEGORY_KEY, Dropdown_meta_1.DROPDOWN_PARENT_COMPONENT_KEY, [Dropdown_meta_1.DROPDOWN_COMPONENT_KEY]);
